import React from "react";
import { Button, ButtonGroup, Row, Col, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import SubSectionSeparator from "../SubSectionSeparator";

const MediaConsentStep = ({ ctx }) => {
  const { formData, handleChange } = ctx;
  return <>
                <SubSectionSeparator title="visual_media_consent" />
                <Row>
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <ButtonGroup className="me-3 ms-0">
                        <Button size="sm" name="pic_nursery" onClick={handleChange} value="1" variant={Number(formData.pic_nursery) === 1 ? "secondary" : "light"}>
                          <FormattedMessage id="yes" />
                        </Button>
                        <Button size="sm" name="pic_nursery" onClick={handleChange} value="0" variant={Number(formData.pic_nursery) === 0 ? "secondary" : "light"}>
                          <FormattedMessage id="no" />
                        </Button>
                      </ButtonGroup>
                      <Form.Label>
                        <FormattedMessage id="social_media_website" />
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <ButtonGroup className="me-3 ms-0">
                        <Button size="sm" name="pic_media" onClick={handleChange} value="1" variant={Number(formData.pic_media) === 1 ? "secondary" : "light"}>
                          <FormattedMessage id="yes" />
                        </Button>
                        <Button size="sm" name="pic_media" onClick={handleChange} value="0" variant={Number(formData.pic_media) === 0 ? "secondary" : "light"}>
                          <FormattedMessage id="no" />
                        </Button>
                      </ButtonGroup>
                      <Form.Label>
                        <FormattedMessage id="advertising" />
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <ButtonGroup className="me-3 ms-0">
                        <Button size="sm" name="pic_social" onClick={handleChange} value="1" variant={Number(formData.pic_social) === 1 ? "secondary" : "light"}>
                          <FormattedMessage id="yes" />
                        </Button>
                        <Button size="sm" name="pic_social" onClick={handleChange} value="0" variant={Number(formData.pic_social) === 0 ? "secondary" : "light"}>
                          <FormattedMessage id="no" />
                        </Button>
                      </ButtonGroup>
                      <Form.Label>
                        <FormattedMessage id="printing" />
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col md={12}>
                    <Form.Group className="mb-4">
                      <ButtonGroup className="me-3 ms-0">
                        <Button size="sm" name="take_pictures" onClick={handleChange} value="1" variant={Number(formData.take_pictures) === 1 ? "secondary" : "light"}>
                          <FormattedMessage id="yes" />
                        </Button>
                        <Button size="sm" name="take_pictures" onClick={handleChange} value="0" variant={Number(formData.take_pictures) === 0 ? "secondary" : "light"}>
                          <FormattedMessage id="no" />
                        </Button>
                      </ButtonGroup>
                      <Form.Label>
                        <FormattedMessage id="educore_app" />
                      </Form.Label>
                    </Form.Group>
                  </Col>
                </Row>
              </>;
};

export default MediaConsentStep;
